import i18nLib from 'i18next'
import { initReactI18next } from 'react-i18next'

import * as english from './en'
import * as spanish from './es'

export const createI18nInstance = () => {
  // the translations
  const resources = {
    en: english,
    es: spanish
  }

  const i18nInstance = i18nLib.createInstance()
  i18nInstance
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      resources,
      lng: 'en',
      fallbackLng: 'en',
      interpolation: {
        escapeValue: false // react already safes from xss
      }
    })
  return i18nInstance
}

const i18n = createI18nInstance()

export default i18n
